import axios from "axios";
export const getUserBySessionId = async (sessionId, role) => {
  try {
    let { data } = await axios.get(
      `${process.env.REACT_APP_API_URL}/user/${sessionId}?role=${role}`
    );
    return data?.data;
  } catch (error) {
    return error?.response?.data;
  }
};

export const getUsersBySessionId = async (sessionId) => {
  try {
    let { data } = await axios.get(
      `${process.env.REACT_APP_API_URL}/users/${sessionId}`
    );
    return data;
  } catch (error) {
    return error?.response?.data;
  }
};

export const getUserByIdApi = async (values) => {
  try {
    let { data } = await axios.get(`${process.env.REACT_APP_API_URL}/user/userDetails/${values.id}?bodyData=${encodeURIComponent(JSON.stringify(values))}`);
    return data?.data?.data;
  } catch (error) {
    return error?.response?.data;
  }
};